import { Record } from 'immutable';

export const MILESTONE_REDUCER_KEY = 'milestonesStore';

export const mkMilestoneDefaults = Record({
  achievementId: undefined,
  createdAt: undefined,
  currentCount: undefined,
  currentAmount: undefined,
  description: undefined,
  content: undefined,
  imageLink: undefined,
  id: undefined,
  knownMilestoneId: undefined,
  limitType: undefined,
  modifiedAt: undefined,
  name: undefined,
  occurenceType: undefined,
  state: undefined,
  status: undefined,
  targetCount: undefined,
  targetAmount: undefined,
  timesAchieved: undefined,
  type: undefined,
  knownMilestoneItemId: undefined,
  completedOn: undefined,
  periodType: undefined,
});

export const mkMilestone = (jsObj = {}) =>
  mkMilestoneDefaults({
    ...jsObj,
  });
